const hostOnboardingService = require('../../services/host/hostOnboardingService')

const state = {
  currentHostOnboardingStepData: {},
  hostOnboardingStepsData: [],
  hostBackgroundCheck: {},
  disapproveTypes: [],
  hostOnboardingStepTypes: [],
  hostOnboardingCoursePercentages: [],
}

const getters = {
  hostOnboardingStepData: (state) => state.currentHostOnboardingStepData,
  hostOnboardingStepsData: (state) => state.hostOnboardingStepsData,
  hostBackgroundCheck: (state) => state.hostBackgroundCheck,
  disapproveTypes: (state) => state.disapproveTypes,
  hostOnboardingStepTypes: (state) => state.hostOnboardingStepTypes,
  hostOnboardingCoursePercentages: (state) =>
    state.hostOnboardingCoursePercentages,
}

const actions = {
  fetchHostBackgroundCheck({ commit }, id) {
    commit('setIsLoading', true)

    hostOnboardingService
      .findBackgroundCheck(id)
      .then(({ data }) => {
        commit('setHostBackgroundCheck', data)
      })
      .catch(() => {
        commit('setHostBackgroundCheck', {})
      })
      .finally(() => {
        commit('setIsLoading', false)
      })
  },

  createHostBackgroundCheck({ commit, dispatch }, id) {
    commit('setIsLoadingButton', true)

    hostOnboardingService
      .createBackgroundCheck(id)
      .then(({ data }) => {
        commit('setHostBackgroundCheck', data)
        commit('closeModal', 'VERIFY_HOST_ONBOARDING')
      })
      .catch(({ data }) => {
        data?.errors && data?.errors?.length >= 1
          ? dispatch('showErrorMessage', data.errors[0].message)
          : dispatch('showErrorMessage', data.message)
      })
      .finally(() => {
        commit('setIsLoadingButton', false)
      })
  },

  nextHostOnboardingStep({ commit, dispatch }, hostId) {
    commit('setIsLoadingButton', true)

    hostOnboardingService
      .nextHostOnboardingStep(hostId)
      .then(({ data }) => {
        commit('setHostOnboardingStepData', data)
        dispatch('fetchHosts')
        commit('closeModal', 'HOST_ONBOARDING_CHANGE_STEP')
        dispatch('showSuccessMessage', 'Passo alterado')
      })
      .catch(({ data }) => {
        data?.errors && data?.errors?.length >= 1
          ? dispatch('showErrorMessage', data.errors[0].message)
          : dispatch('showErrorMessage', data.message)
      })
      .finally(() => {
        commit('setIsLoadingButton', false)
      })
  },

  changeHostOnboardingStep({ commit, dispatch }, request) {
    commit('setIsLoadingButton', true)

    hostOnboardingService
      .changeHostOnboardingStep(request)
      .then(({ data }) => {
        commit('setHostOnboardingStepData', data.host_onboarding_step)
        commit('closeModal', 'HOST_ONBOARDING_CHANGE_STEP')
        dispatch('showSuccessMessage', 'Passo alterado')
      })
      .catch(({ data }) => {
        data?.errors && data?.errors?.length >= 1
          ? dispatch('showErrorMessage', data.errors[0].message)
          : dispatch('showErrorMessage', data.message)
      })
      .finally(() => {
        commit('setIsLoadingButton', false)
      })
  },

  async addFeedbackMessage({ commit, dispatch }, request) {
    commit('setIsLoadingButton', true)

    await hostOnboardingService
      .addFeedbackMessage(request)
      .then(({ data }) => {
        commit('setHostOnboardingStepData', data)
      })
      .catch(({ data }) => {
        data?.errors && data?.errors?.length >= 1
          ? dispatch('showErrorMessage', data.errors[0].message)
          : dispatch('showErrorMessage', data.message)
      })
      .finally(() => {
        commit('setIsLoadingButton', false)
      })
  },

  async fetchHostOnboardingStepData({ commit, dispatch }, id) {
    commit('setIsLoading', true)

    hostOnboardingService
      .findHostCurrentOnboardingStep(id)
      .then(({ data }) => {
        commit('setHostOnboardingStepData', data)
      })
      .catch(({ data }) => {
        data?.errors && data?.errors?.length >= 1
          ? dispatch('showErrorMessage', data.errors[0].message)
          : dispatch('showErrorMessage', data.message)
      })
      .finally(() => {
        commit('setIsLoading', false)
      })
  },

  async fetchHostOnboardingStepsData({ dispatch, commit }, hostId) {
    commit('setIsLoading', true)
    hostOnboardingService
      .findAllSteps(hostId)
      .then(({ data }) => {
        commit('setHostOnboardingStepsData', data)
      })
      .catch(({ data }) => {
        data?.errors && data?.errors?.length >= 1
          ? dispatch('showErrorMessage', data.errors[0].message)
          : dispatch('showErrorMessage', data.message)
      })
      .finally(() => {
        commit('setIsLoading', false)
      })
  },

  disapproveHostOnboarding({ dispatch, commit }, request) {
    commit('setIsLoadingButton', true)

    hostOnboardingService
      .disapproveHostOnboarding(request)
      .then(({ data }) => {
        commit('setHostOnboardingStepData', data)
        dispatch('fetchHosts')
        commit('closeModal', 'REPROVE_HOST_ONBOARDING')
        dispatch('showSuccessMessage', 'Candidato reprovado com sucesso')
      })
      .catch(({ data }) => {
        data?.errors && data?.errors?.length >= 1
          ? dispatch('showErrorMessage', data.errors[0].message)
          : dispatch('showErrorMessage', data.message)
      })
      .finally(() => {
        commit('setIsLoadingButton', false)
      })
  },

  readHostOnboardingStepFiles({ dispatch, commit }, hostId) {
    commit('setIsLoading', true)

    hostOnboardingService
      .readHostOnboardingStepFiles(hostId)
      .then(() => {
        dispatch('fetchHosts')
      })
      .catch(({ data }) => {
        data?.errors && data?.errors?.length >= 1
          ? dispatch('showErrorMessage', data.errors[0].message)
          : dispatch('showErrorMessage', data.message)
      })
      .finally(() => {
        commit('setIsLoading', false)
      })
  },

  fetchDisapproveTypes({ commit, dispatch }) {
    commit('setIsLoading', true)

    hostOnboardingService
      .fetchDisapproveTypes()
      .then(({ data }) => {
        commit('setDisapproveTypes', data)
      })
      .catch(({ data }) => {
        data?.errors && data?.errors?.length >= 1
          ? dispatch('showErrorMessage', data.errors[0].message)
          : dispatch('showErrorMessage', data.message)
      })
      .finally(() => {
        commit('setIsLoading', false)
      })
  },

  fetchHostOnboardingStepTypes({ commit, dispatch }) {
    commit('setIsLoading', true)

    hostOnboardingService
      .fetchHostOnboardingStepTypes()
      .then(({ data }) => {
        commit('setHostOnboardingStepTypes', data)
      })
      .catch(({ data }) => {
        data?.errors && data?.errors?.length >= 1
          ? dispatch('showErrorMessage', data.errors[0].message)
          : dispatch('showErrorMessage', data.message)
      })
      .finally(() => {
        commit('setIsLoading', false)
      })
  },

  fetchHostOnboardingCoursePercentages({ commit, dispatch }) {
    commit('setIsLoading', true)

    hostOnboardingService
      .fetchHostOnboardingCoursePercentages()
      .then(({ data }) => {
        commit('setHostOnboardingCoursePercentages', data)
      })
      .catch(({ data }) => {
        data?.errors && data?.errors?.length >= 1
          ? dispatch('showErrorMessage', data.errors[0].message)
          : dispatch('showErrorMessage', data.message)
      })
      .finally(() => {
        commit('setIsLoading', false)
      })
  },

  changeCoursePercentage({ dispatch, commit }, request) {
    commit('setIsLoadingButton', true)

    hostOnboardingService
      .changeCoursePercentage(request)
      .then(({ data }) => {
        commit('setHostOnboardingStepData', data)
        dispatch('fetchHosts')
        dispatch('showSuccessMessage', 'Progresso do curso alterado!')
      })
      .catch(({ data }) => {
        data?.errors && data?.errors?.length >= 1
          ? dispatch('showErrorMessage', data.errors[0].message)
          : dispatch('showErrorMessage', data.message)
      })
      .finally(() => {
        commit('setIsLoadingButton', false)
      })
  },
}

const mutations = {
  setHostOnboardingStepData: (state, currentHostOnboardingStepData) => {
    state.currentHostOnboardingStepData = currentHostOnboardingStepData
  },
  setHostOnboardingStepsData: (state, hostOnboardingStepsData) => {
    state.hostOnboardingStepsData = hostOnboardingStepsData
  },
  setHostBackgroundCheck: (state, hostBackgroundCheck) => {
    state.hostBackgroundCheck = hostBackgroundCheck
  },
  setHostOnboardingStepTypes: (state, hostOnboardingStepTypes) => {
    state.hostOnboardingStepTypes = hostOnboardingStepTypes
  },
  setHostOnboardingCoursePercentages: (
    state,
    hostOnboardingCoursePercentages
  ) => {
    state.hostOnboardingCoursePercentages = hostOnboardingCoursePercentages
  },
  setDisapproveTypes: (state, disapproveTypes) => {
    state.disapproveTypes = disapproveTypes
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
